import { useMemo } from 'react';
import { Box, Stack } from '@mui/material';

import IdeaCard from '../../cards/IdeaCard';

import type { BoardLayout } from '../../../interfaces/BoardDetails';
import type { Idea } from '../../../interfaces/Idea';

type AutomaticBoardCardsProps = {
  orderedIdeas: Idea[];
  layout: BoardLayout;
  laneCount: number;
};

const AutomaticBoardCards = ({
  orderedIdeas,
  layout,
  laneCount,
}: AutomaticBoardCardsProps) => {
  const laneColumns = useMemo(() => {
    const columns = Array.from({ length: laneCount }, () => [] as Idea[]);

    orderedIdeas.forEach((idea, index) => {
      columns[index % laneCount].push(idea);
    });

    return columns;
  }, [orderedIdeas, laneCount]);

  if (layout === 'grid') {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'repeat(3, minmax(0, 1fr))',
            md: 'repeat(4, minmax(0, 1fr))',
            lg: 'repeat(4, minmax(0, 1fr))',
          },
          alignItems: 'start',
          gap: 2,
        }}
      >
        {orderedIdeas.map((idea) => (
          <Box key={idea.id}>
            <IdeaCard ideaId={idea.id} />
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: `repeat(${laneCount}, minmax(0, 1fr))`,
        alignItems: 'start',
        gap: 2,
      }}
    >
      {laneColumns.map((columnIdeas, columnIndex) => (
        <Stack key={`lane-column-${columnIndex}`} spacing={2}>
          {columnIdeas.map((idea) => (
            <Box key={idea.id}>
              <IdeaCard ideaId={idea.id} />
            </Box>
          ))}
        </Stack>
      ))}
    </Box>
  );
};

export default AutomaticBoardCards;
